export const GET_ADMIN_PROMOTIONAL_BANNER_META_PENDING = 'GET_ADMIN_PROMOTIONAL_BANNER_META_PENDING';
export const GET_ADMIN_PROMOTIONAL_BANNER_META_FULFILLED = 'GET_ADMIN_PROMOTIONAL_BANNER_META_FULFILLED';
export const GET_ADMIN_PROMOTIONAL_BANNER_META_REJECTED = 'GET_ADMIN_PROMOTIONAL_BANNER_META_REJECTED';

export function promotionalBannersReducer(state = {
  fetching: true,
  fetched: false,
  promotion: {},
  groupList: {},
  meta: {},
  errors: {},
  categoryList: [],
  promotional_banners: []
}, action) {
  switch (action.type) {
    case 'GET_PROMOTIONAL_BANNER_LIST_PENDING':
    case 'GET_PROMOTIONAL_BANNERS_FOR_NEW_ORDER_PAGE_PENDING':
    case 'GET_PROMOTIONAL_BANNER_PENDING':
    case GET_ADMIN_PROMOTIONAL_BANNER_META_PENDING: {
      return { ...state, fetching: true, fetched: false }
    }
    case 'GET_PROMOTIONAL_BANNERS_FOR_NEW_ORDER_PAGE_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        promotional_banners: action.payLoad.data,
      }
    }
    case 'GET_PROMOTIONAL_BANNER_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        promotional_banners: action.payLoad.data,
        groupList: action.payLoad.meta.groups,
        categoryList: action.payLoad.meta.categories
      }
    }
    case 'GET_PROMOTIONAL_BANNERS_FOR_NEW_ORDER_PAGE_REJECTED':
    case 'GET_PROMOTIONAL_BANNER_LIST_REJECTED':
    case 'CLEAR_PROMOTIONAL_BANNERS': {
      return {
        ...state,
        promotional_banner: [],
        groupList: [],
        categoryList: []
      }
    }
    case 'GET_PROMOTIONAL_BANNER_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        promotional_banner: action.payLoad,
        saved: false,
      }
    }
    case 'SAVE_PROMOTIONAL_BANNER_REJECTED':
    case 'GET_PROMOTIONAL_BANNER_REJECTED': {
      return {...state, errors: action.payLoad.errors}
    }
    case GET_ADMIN_PROMOTIONAL_BANNER_META_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        meta: action.payload.meta
      };
    }
    case GET_ADMIN_PROMOTIONAL_BANNER_META_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        meta: {}
      };
    }
  }

  return { ...state };
}



// WEBPACK FOOTER //
// ./src/reducers/promotionalBannersReducer.js